module.exports = __webpack_public_path__ + "static/media/Nach_dem_Rosenmontagszug_bei_Edith.445a6a23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_karneval/thumb/Nach_dem_Rosenmontagszug_bei_Edith.jpg
// module id = 496
// module chunks = 0